export default __webpack_public_path__ + "96da765307b4335286cfd812ed3a940d.svg";